import React from "react";
import StripePayForm from "./StripePayForm";
import ModalBasicLayout from "../Modal/ModalBasicLayout";
import { useTranslationApp } from "../../../lib/i18next";
import { ADD, ADD_CARD } from "../../../locales/keysTranslations";

const ModalStripeAddCard = ({
  modalOpen,
  onCloseModal,
  onSubmit,
  saveCard,
  setDefaultCard,
}) => {
  const { t } = useTranslationApp();
  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      fullWidth={true}
      scroll="paper"
      ariaLabel={t(ADD_CARD)}
      title={t(ADD_CARD)}
    >
      <StripePayForm
        textButton={ADD}
        onSubmit={onSubmit}
        saveCard={saveCard}
        setDefaultCard={setDefaultCard}
      />
    </ModalBasicLayout>
  );
};

export default ModalStripeAddCard;
